import React from "react";
import "../styles/Component_Calendar.css";

const monthsToRender = [
  "2024-01",
  "2024-02",
  "2024-03",
  "2024-04",
  "2024-05",
  "2024-06",
  "2024-07",
  "2024-08",
  "2024-09",
  "2024-10",
  "2024-11",
  "2024-12",
  "2025-01",
  "2025-02",
  "2025-03",
  "2025-04",
  "2025-05",
  "2025-06",
  "2025-07",
  "2025-08",
  "2025-09",
  "2025-10",
  "2025-11",
  "2025-12",
  "2026-01",
  "2026-02",
  "2026-03",
  "2026-04",
  "2026-05",
  "2026-06",
  "2026-07",
  "2026-08",
  "2026-09",
  "2026-10",
  "2026-11",
  "2026-12",
];
const today = new Date().toISOString().slice(0, 10);

function getDaysInMonth(ym) {
  const [year, month] = ym.split("-").map(Number);
  const date = new Date(year, month - 1, 1);
  const days = [];

  while (date.getMonth() === month - 1) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return days;
}

export default function Component_Calendar({ appointments }) {
  const getAppointments = (dateStr) =>
    appointments.filter((a) => a.date === dateStr);

  const handleDayClick = (dateStr) => {
    // Hier kannst du später alles machen (Popup, Modal, Navigation etc.)
    console.log("Geklickter Tag:", dateStr);
  };

  return (
    <div className="calendar-wrapper">
      <div className="weekday-bar">
        {["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"].map((d) => (
          <div key={d} className="weekday">
            {d}
          </div>
        ))}
      </div>

      <div className="calendar-scroll">
        {monthsToRender.map((ym) => (
          <div key={ym} className="month-block">
            {(() => {
              const [year, month] = ym.split("-").map(Number);
              const displayDate = new Date(year, month - 1, 1);
              return (
                <h3>
                  {displayDate.toLocaleString("de-DE", {
                    month: "long",
                    year: "numeric",
                  })}
                </h3>
              );
            })()}

            <div className="month-grid">
              {(() => {
                const days = getDaysInMonth(ym);
                const offset = (days[0].getDay() + 6) % 7; // Montag als Start
                return [
                  ...Array(offset)
                    .fill(null)
                    .map((_, i) => (
                      <div key={`e${i}`} className="day-cell empty" />
                    )),
                  ...days.map((day) => {
                    const dateStr = day.toISOString().slice(0, 10);
                    const dailyAppointments = getAppointments(dateStr);
                    const isToday = dateStr === today;

                    return (
                      <div
                        key={dateStr}
                        className={`day-cell ${isToday ? "today" : ""}`}
                        onClick={() => handleDayClick(dateStr)}>
                        <div className="day-number">{day.getDate()}</div>
                        {dailyAppointments.map((appt, idx) => (
                          <div key={idx} className="badge">
                            {appt.label}
                          </div>
                        ))}
                      </div>
                    );
                  }),
                ];
              })()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
